import { CircularLayout } from '@antv/layout/lib/layout/circular';

export default CircularLayout;
